import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SortLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5 7h14M5 12h10M5 17h6" })));
}
const SortLight = forwardRef(_SortLight);
export { SortLight };
